var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBtnDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1020 -308)translate(225 147)translate(20 161)translate(775 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    className: "icon-bg"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.631579 11.578947)",
    className: "icon-color"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "14.1 2.8 14.1 16.9 1.7 16.9 1.7 2.8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.9,
    y1: 6.8,
    x2: 7.9,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.1,
    y1: 6.8,
    x2: 5.1,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7,
    y1: 6.8,
    x2: 10.7,
    y2: 13
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5.1 2.8 5.1 0 10.7 0 10.7 2.8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.8,
    y1: 2.8,
    y2: 2.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnDelete);
export default __webpack_public_path__ + "static/media/icBtnDelete.0775a0af20bdef406eec99e4aeaf4224.svg";
export { ForwardRef as ReactComponent };